import { Heading } from '@tiptap/extension-heading';

/*
    This is a temporary fix to deal with the fact that the tiptap editor's
    Heading's content is not compatible with prosemirrors heading's content.
    This brings the content inline with prosemirror.

    Current a prosemirror editor can interact with content generated by a
    tiptap editor, so this was risking issues on loading the content into
    the editor. We shouldchange this back to the default after the
    prosemirror editor is removed. The default behvior can handle the content
    used by our prosemirror schema, so switching back should be simple.
*/
export const CustomHeading = Heading.extend({
   content: 'text*',
   group: 'block quoteless',
   inline: false,
});
